<template>
  <div class="tv-hls__video-container">
    <video
      ref="video"
      class="video"
      autoplay
      muted
      playsinline
      loop
      :controls="false"
    ></video>
  </div>
</template>

<script>
import Hls from "hls.js";
export default {
  name: "TvHls",
  data() {
    return {
      hls: null,
      refreshInterval: null,
    };
  },
  mounted() {
    this.initializePlayer();
    // Set up periodic refresh every 5 minutes
    this.refreshInterval = setInterval(() => {
      this.initializePlayer();
    }, 5 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.hls) {
      this.hls.destroy();
    }
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  methods: {
    initializePlayer() {
      const video = this.$refs.video;
      if (this.hls) {
        this.hls.destroy();
      }

      this.hls = new Hls();
      this.hls.loadSource(
        "https://livepeercdn.studio/hls/8d33n2at0gq7aud6/index.m3u8"
      );
      this.hls.attachMedia(video);

      // Handle HLS.js events
      this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play().catch(() => {
          // Silent fail for autoplay prevention
        });
      });
    },
  },
};
</script>

<style>
.tv-hls__video-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
